import { ENTER } from '@angular/cdk/keycodes';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { RootScopeService } from '../../../services/root-scope.service';
declare var $: any;

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrls: ['./custom-dialog.component.scss'],
  host: { '(window:keydown)': 'browserEvent($event)' },
})
export class CustomDialogComponent implements OnInit {
  @Input() additionalClass: any;
  @Output() actionOnClick = new EventEmitter();

  constructor(public rootScope: RootScopeService) { }

  ngOnInit(): void { }

  buttonClicked(buttonLabel) {

    let data = {
      type: this.rootScope.customDialogData.type,
      buttonType: buttonLabel,
      msg: this.rootScope.customDialogData.msg
    };
    this.actionOnClick.emit(data);
    if (this.rootScope.customDialogData.displayCustomDialog)
      this.rootScope.customDialogData.displayCustomDialog = false;

    if (this.rootScope.customDialogData.displayCustomDialogCS)
      this.rootScope.customDialogData.displayCustomDialogCS = false;

    if (this.rootScope.customDialogData.displayCustomDialogCA)
      this.rootScope.customDialogData.displayCustomDialogCA = false;
  }

  browserEvent(event) {
    if (event.keyCode == ENTER) this.buttonClicked(event.target.innerText);
  }
}
